import * as swcHelpers from '@swc/helpers';
import { SET_FEATURE_TOGGLES } from './actions.js';

function featureTogglereducer(state = null, action) {
    switch(action.type){
        case SET_FEATURE_TOGGLES:
            return swcHelpers.objectSpread({}, state, action.payload);
        default:
            return state;
    }
}

export { featureTogglereducer as default };
//# sourceMappingURL=reducer.js.map
